var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    { 'qt-loader qt-loader-mini qt-loader-right': _vm.loading },
    `btn btn-${_vm.type}`,
  ],attrs:{"disabled":_vm.loading},on:{"click":_vm.click}},[_vm._t("default",function(){return [_vm._v("Button")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }